import Vue from 'vue'
import i18n from '@/lang/i18n'
import { isBeforeOrderFoodEntrySwitchDate } from '@/js/utils/orderFood'

export default [
  {
    path: '/point/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: 'orderFood', // 書籤/主選單用，由 beforeEnter 依日期導向 V2 或 V3
        name: 'pointOrderFood',
        component: () => import('@/views/Point/OrderFood/OrderFoodEntry.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: 'orderFoodV2', // 點餐入口頁(V2)
        name: 'orderFoodV2',
        component: () => import('@/views/Point/OrderFood/OrderFood.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        },
        beforeEnter: (to, from, next) => {
          next({ name: 'orderFoodV3', replace: true })
        }
      },
      {
        path: 'orderFoodV3', // 點餐入口頁
        name: 'orderFoodV3',
        component: () => import('@/views/Point/OrderFood/OrderFoodEntry.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'orderFoodItemManagement', // 點餐使用項目管理
        name: 'orderFoodItemManagement',
        component: () => import('@/views/Point/OrderFood/OrderFoodItemManagement.vue'),
        meta: {
          prev: 'orderFoodV2'
        },
        beforeEnter: (to, from, next) => {
          to.meta.prev = isBeforeOrderFoodEntrySwitchDate() ? 'orderFoodV2' : 'orderFoodV3'
          next()
        }
      },
      {
        path: 'orderFoodMenuEdit/:id',
        name: 'orderFoodMenuEdit',
        component: () => import('@/views/Point/OrderFood/OrderFoodMenuEdit.vue'),
        meta: {
          prev: 'orderFoodItemManagement'
        }
      },
      {
        path: 'orderFoodSpecEdit/:id',
        name: 'orderFoodSpecEdit',
        component: () => import('@/views/Point/OrderFood/OrderFoodSpecEdit.vue'),
        meta: {
          prev: 'orderFoodItemManagement'
        }
      },
      {
        path: 'orderFoodRecord', // 舊點餐紀錄(V1)
        name: 'pointOrderFoodRecord',
        component: () => import('@/views/Point/OrderFood/OrderFoodRecord.vue'),
        meta: {
          prev: 'orderFoodRecordList',
          title: i18n.t('OrderFoodRecord.Title'),
          tip: i18n.t('OrderFoodRecord.Tip')
        },
        beforeEnter: (to, from, next) => {
          to.meta.prev = isBeforeOrderFoodEntrySwitchDate() ? 'orderFoodRecordList' : 'orderFoodManagement'
          next()
        }
      },
      {
        path: 'orderFoodRecordList', // 點餐紀錄列表(V2)
        name: 'orderFoodRecordList',
        component: () => import('@/views/Point/OrderFood/OrderFoodRecordList.vue'),
        meta: {
          prev: 'orderFoodV2'
        },
        beforeEnter: (to, from, next) => {
          to.meta.prev = isBeforeOrderFoodEntrySwitchDate() ? 'orderFoodV2' : 'orderFoodV3'
          next()
        }
      },
      {
        path: 'orderFoodExportReport', // 匯出點餐報表
        name: 'orderFoodExportReport',
        component: () => import('@/views/Point/OrderFood/OrderFoodExportReport.vue'),
        meta: {
          prev: 'orderFoodRecordList'
        },
        beforeEnter: (to, from, next) => {
          to.meta.prev = isBeforeOrderFoodEntrySwitchDate() ? 'orderFoodRecordList' : 'orderFoodManagement'
          next()
        }
      },
      {
        path: 'orderFoodCounter', // 櫃檯點餐
        name: 'orderFoodCounter',
        component: () => import('@/views/Point/OrderFood/OrderFoodCounter.vue'),
        meta: {
          prev: 'orderFoodV3',
          keepAlive: true
        }
      },
      {
        path: 'orderFoodPickup', // 住戶取餐
        name: 'orderFoodPickup',
        component: () => import('@/views/Point/OrderFood/OrderFoodPickup.vue'),
        meta: {
          prev: 'orderFoodV3'
        }
      },
      {
        path: 'orderFoodManagement', // 餐點訂單
        name: 'orderFoodManagement',
        component: () => import('@/views/Point/OrderFood/OrderFoodManagement.vue'),
        meta: {
          prev: 'orderFoodV3'
        }
      },
      {
        path: 'orderFoodTableQrCodePrint', // 列印桌號QRCode
        name: 'orderFoodTableQrCodePrint',
        component: () => import('@/views/Point/OrderFood/OrderFoodTableQrCodePrint.vue'),
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none',
          isNoNeedToLogin: true
        }
      },
      {
        path: 'report',
        name: 'pointReport',
        component: () => import('@/views/Point/ReportView.vue'),
        meta: {
          prev: 'mainPage/pointManage'
        }
      },
      {
        path: 'noteTemplate',
        name: 'noteTemplate',
        component: () => import('@/views/Point/NoteTemplate.vue'),
        meta: {
          prev: 'mainPage/pointManage'
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.getItem('loginUserInfo') && !JSON.parse(localStorage.getItem('loginUserInfo'))) {
        Vue.prototype.$alert('登入過期或驗證失敗，請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          next({ name: 'LoginMain' })
        })
      } else {
        if (to.path === '/point/orderFood') {
          next({ name: 'orderFoodV3' })
        } else {
          next()
        }
      }
    }
  }
]
